// extracted by mini-css-extract-plugin
export default {"main_container":"MainLayout_main_container__vQL3E"};